import { customConfirm } from "@/ui/confirm";

/** PageBox callers only. Never send an unsupported APK to BookTox web login. */
export function pageboxAuthPath(path: string, qrEntry: boolean) {
    return `${path}?app_id=pagebox${qrEntry ? "&entry=qr" : ""}`;
}

export async function returnToPageboxLogin(qrEntry = false) {
    if (qrEntry) {
        await customConfirm(
            "이미 가입하셨다면 페이지박스 기기에서 기존 아이디와 비밀번호로 로그인해주세요.",
            "확인",
        );
        return;
    }
    const bridge = (window as any).PageBoxAuth;
    if (typeof bridge?.close === "function") {
        try {
            bridge.close();
            return;
        } catch {
            // Older/unsupported hosts keep the current page and explain how to leave.
        }
    }
    await customConfirm(
        "페이지박스 앱의 로그인 화면에서 로그인해주세요. 기기의 뒤로가기 버튼으로 이 화면을 나갈 수 있습니다.",
        "확인",
    );
}
